import { getStorageItem } from "../helpers/utils";
import {
  DEFAULT_BANK_MICR_CODE,
  SLUG_DIFFERENT,
  SLUG_SAME,
  SLUG_NOT_AVAILABLE,
  SLUG_AVAILABLE,
  SLUG_SAVINGS,
} from "../constants";

export const autoCompleteObject = null;

export const errorMessageObject = {
  nominee_name: "",
  nominee_dob: "",
  nominee_relationship: "",
  nominee_gender: "",
  nominee_bank_account_holder_name: "",
  nominee_bank_account_number: "",
  nominee_bank_name: "",
  nominee_bank_account_type: "",
  nominee_bank_micr_code: "",
  nominee_bank_ifsc_code: "",

  appointee_name: "",
  appointee_dob: "",
  appointee_relationship: "",
  appointee_gender: "",
  appointee_bank_account_holder_name: "",
  appointee_bank_account_number: "",
  appointee_bank_name: "",
  appointee_bank_account_type: "",
  appointee_bank_micr_code: "",
  appointee_bank_ifsc_code: "",
};

export const formObject = {
  nominee_name: "",
  nominee_dob: "",
  nominee_relationship: "",
  nominee_gender: "",

  nominee_age: "",
  partnerId: getStorageItem("partnerId"),
  declaration: true,

  nominee_mobile_available: SLUG_NOT_AVAILABLE,
  nominee_mobile_same_as_owner: SLUG_DIFFERENT,
  nominee_mobile: "",
  nominee_email: "",

  nominee_email_available: SLUG_NOT_AVAILABLE,
  nominee_email_same_as_owner: SLUG_DIFFERENT,

  nominee_bank_details_available: SLUG_AVAILABLE,
  nominee_bank_details_same_as_owner: SLUG_DIFFERENT,
  nominee_bank_account_holder_name: "",
  nominee_bank_account_number: "",
  nominee_bank_name: "",
  nominee_bank_account_type: SLUG_SAVINGS,
  nominee_bank_micr_code: DEFAULT_BANK_MICR_CODE,
  nominee_bank_ifsc_code: "",

  appointee_name: "",
  appointee_dob: "",
  appointee_relationship: "",
  appointee_gender: "",

  appointee_mobile_available: SLUG_NOT_AVAILABLE,
  appointee_mobile_same_as_owner: SLUG_DIFFERENT,
  appointee_mobile: "",

  appointee_email_available: SLUG_NOT_AVAILABLE,
  appointee_email_same_as_owner: SLUG_DIFFERENT,
  appointee_email: "",

  appointee_bank_details_available: SLUG_AVAILABLE,
  appointee_bank_details_same_as_owner: SLUG_DIFFERENT,
  appointee_bank_account_holder_name: "",
  appointee_bank_account_number: "",
  appointee_bank_name: "",
  appointee_bank_account_type: SLUG_SAVINGS,
  appointee_bank_micr_code: DEFAULT_BANK_MICR_CODE,
  appointee_bank_ifsc_code: "",
};

export const sectionObject = {
  nomineePersonal: true,
  nomineeBank: false,

  appointeePersonal: false,
  appointeeBank: false,
};

export const touchFieldObject = {
  nominee_name: false,
  nominee_dob: false,
  nominee_relationship: false,
  nominee_gender: false,

  appointee_name: false,
  appointee_dob: false,
  appointee_relationship: false,
  appointee_gender: false,
  appointee_bank_account_holder_name: false,
  appointee_bank_account_number: false,
  appointee_bank_name: false,
  appointee_bank_account_type: false,
  appointee_bank_micr_code: false,
  appointee_bank_ifsc_code: false,
};

export const relationGenderMapping = {
  Wife: "Female",
  Husband: "Male",
  Mother: "Female",
  Father: "Male",
  Daughter: "Female",
  Son: "Male",
  Grandmother: "Female",
  Grandfather: "Male",
};

export const optionMapping = {
  "": "",
  Same: 1,
  Different: 0,
  Available: 1,
  "Not Available": 0,
};

export const options = {
  gender: [
    {
      title: "Male",
      value: "Male",
    },
    {
      title: "Female",
      value: "Female",
    },
  ],
  availableOrNot: [
    {
      title: "Available",
      value: "Available",
    },
    {
      title: "Not Available",
      value: "Not Available",
    },
  ],
  sameOrDifferent: [
    {
      title: "Same",
      value: "Same",
    },
    {
      title: "Different",
      value: "Different",
    },
  ],
  bankAccountType: [
    { title: "Savings", value: "Savings" },
    { title: "Current", value: "Current" },
  ],
};
